module.exports = __webpack_public_path__ + "static/media/ic_ruzhu_team@2x.a9580257.png";